var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 2.91663H9.16683C6.41697 2.91663 5.04204 2.91663 4.18777 3.7709C3.3335 4.62517 3.3335 6.0001 3.3335 8.74996V12.5C3.3335 15.2498 3.3335 16.6247 4.18777 17.479C5.04204 18.3333 6.41697 18.3333 9.16683 18.3333H11.6668L16.6668 13.3333V8.74996C16.6668 6.0001 16.6668 4.62517 15.8126 3.7709C14.9582 2.91663 13.5833 2.91663 10.8335 2.91663Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 11.6667H9.58317M6.6665 8.33337H13.3332",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 13.3334C14.3095 13.3334 13.131 13.3334 12.3988 14.0656C11.6665 14.7979 11.6665 15.9764 11.6665 18.3334",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.66663V4.16663M6.25 1.66663V4.16663M10 1.66663V4.16663",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.764348f726bda8d5c2ca965b27284e21.svg";
export { ForwardRef as ReactComponent };